import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ADMIN_PANEL_HOME,
  getAuthPayload,
  getUserTypeName,
  isAdminUser,
} from "../../admin/navigation/adminNavigation";

/**
 * Strictly PARTNER-only (unlike <Protected>, super admins get no bypass). Anyone else is sent to
 * their own dashboard and never renders the children.
 */
const PartnerOnlyRoute = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();
  const user = getAuthPayload(authState);

  if (!authState?.isAuthenticated || !user?.accessToken) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  const userType = String(getUserTypeName(authState) || "").toUpperCase().trim();
  if (userType === "PARTNER") {
    return children;
  }

  if (isAdminUser(authState)) {
    return <Navigate to={ADMIN_PANEL_HOME} replace />;
  }

  return <Navigate to="/customer/workspace" replace />;
};

export default PartnerOnlyRoute;
